import dayjs from "dayjs"

export const cardExpired = card => {
  return (
    card.exp_year < dayjs().format("YYYY") ||
    (card.exp_year === dayjs().format("YYYY") && card.exp_month < dayjs().format("M"))
  )
}
